module.exports = __webpack_public_path__ + "img/french_black_ba_list.1315e1eb.jpg";